import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nav${scrolled ? ' is-scrolled' : ''}${open ? ' is-open' : ''}`}>
      <Link to="/" className="logo">
        <svg className="logo-mark" viewBox="0 0 32 32" aria-hidden="true">
          <rect x="1" y="1" width="30" height="30" rx="8" fill="none" stroke="#c8f542" />
          <path d="M8 22 C 12 16, 16 18, 18 13 S 24 8, 25 7" fill="none" stroke="#6ee7ff" strokeWidth="2" />
          <circle cx="25" cy="7" r="2" fill="#c8f542" />
        </svg>
        FuturePathTech
      </Link>
      <button
        className="menu-toggle"
        type="button"
        aria-label="Toggle menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {open ? 'Close' : 'Menu'}
      </button>
      <nav className="nav-links">
        <a href="/#products">Products</a>
        <NavLink to="/ping">Ping</NavLink>
        <NavLink to="/post">Post</NavLink>
        <a href="/#pricing">Pricing</a>
        <a href="/#contact">Contact</a>
      </nav>
      <div className="nav-cta">
        {user ? (
          <>
            <NavLink to="/account">Billing</NavLink>
            <button className="btn btn-ghost" type="button" onClick={logout}>
              Log out
            </button>
          </>
        ) : (
          <>
            <NavLink to="/login">Log in</NavLink>
            <Link className="btn btn-solid" to="/register">
              Get CRM
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
